// assets/theme.js

export default {
  default: {
    light: {
      primary: '#383838',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FFC107'
    },
    dark: {
      primary: '#1976D2',
      accent: '#424242',
      secondary: '#FF8F00',
      info: '#26A69A',
      warning: '#FFC107',
      error: '#DD2C00',
      success: '#00E676'
    }
  },
  reco: {
    light: {
      primary: '#01a455',
      accent: '#75e5ff',
      error: '#f44336',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#f44336'
    },
    dark: {
      primary: '#1976D2',
      accent: '#424242',
      secondary: '#FF8F00',
      info: '#26A69A',
      warning: '#FFC107',
      error: '#DD2C00',
      success: '#00E676'
    }
  },
  dark: {
    light: {
      primary: '#383838',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FFC107'
    },
    dark: {
      primary: '#1976D2',
      accent: '#424242',
      secondary: '#FF8F00',
      info: '#26A69A',
      warning: '#FFC107',
      error: '#DD2C00',
      success: '#00E676'
    }
  },
  healthy: {
    light: {
      primary: '#383838',
      secondary: '#424242',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FFC107'
    },
    dark: {
      primary: '#1976D2',
      accent: '#424242',
      secondary: '#FF8F00',
      info: '#26A69A',
      warning: '#FFC107',
      error: '#DD2C00',
      success: '#00E676'
    }
  },
  rhar: {
    light: {
      primary: '#9ead9e',
      secondary: '#262329',
      accent: '#82B1FF',
      error: '#292323',
      info: '#2196F3',
      success: '#232923',
      warning: '#292923'
    },
    dark: {
      primary: '#1976D2',
      accent: '#424242',
      secondary: '#FF8F00',
      info: '#26A69A',
      warning: '#FFC107',
      error: '#DD2C00',
      success: '#00E676'
    }
  },
  clothing: {
    light: {
      primary: '#EF2B7C',
      secondary: '#414664',
      accent: '#82B1FF',
      error: '#ef2b2b',
      info: '#2196F3',
      success: '#2bef2b',
      warning: '#efef2b'
    },
    dark: {
      primary: '#1976D2',
      accent: '#424242',
      secondary: '#FF8F00',
      info: '#26A69A',
      warning: '#FFC107',
      error: '#DD2C00',
      success: '#00E676'
    }
  },
  avenia: {
    light: {
      primary: '#37b3bd',
      secondary: '#414664',
      accent: '#82B1FF',
      error: '#bd3737',
      info: '#2196F3',
      success: '#37bd37',
      warning: '#bdbd37'
    },
    dark: {
      primary: '#1976D2',
      accent: '#424242',
      secondary: '#FF8F00',
      info: '#26A69A',
      warning: '#FFC107',
      error: '#DD2C00',
      success: '#00E676'
    }
  }

};
